
<portal to="modal" v-if="isOpen">
    <Modal
        :show="isOpen"
        size="large"
        @onModalClose="handleClose"
        class="EntityDetailsModal-Modal"
    >
        <template #header>
            <EntityDetailsHeader
                :entity-type="entityType"
                :entity-name="entityName"
                :entity-subtitle="entitySubtitle"
            />
        </template>

        <div class="EntityDetailsModal">
            <div v-if="isLoading" class="EntityDetailsModal-Loading">
                <div class="loading-spinner"></div>
                <p>Daten werden geladen...</p>
            </div>

            <template v-else>
                <EntityDetailsStats :is-loading="isLoading" :stats="calculatedStats" />

                <div
                    v-if="entityType === 'driver' && driverCashJournal"
                    class="EntityDetailsModal-CashJournal"
                >
                    <h3 class="cash-journal-title">Kassenbuch</h3>
                    <div class="cash-journal-grid">
                        <OverviewMetricCard
                            title="Kassenstand"
                            :value="cashJournalBalance"
                            icon="ri-wallet-3-line"
                            theme="green"
                            size="small"
                            :loading="isLoading"
                        />
                        <OverviewMetricCard
                            title="Transaktionen"
                            :value="cashJournalTransactionsCount"
                            icon="ri-exchange-line"
                            theme="blue"
                            size="small"
                            :loading="isLoading"
                        />
                        <OverviewMetricCard
                            title="Tagesberichte"
                            :value="cashJournalReportsCount"
                            icon="ri-file-list-3-line"
                            theme="orange"
                            size="small"
                            :loading="isLoading"
                        />
                    </div>
                </div>

                <EntityDetailsChart
                    :shifts="shifts"
                    :current-month="currentMonth"
                    :is-loading="isLoading"
                />

                <Tabs v-model="activeTableTab" :tabs="tableTabs">
                    <template #default="{ active }">
                        <div v-if="active === 'shifts'">
                            <EntityDetailsShifts :shifts="shifts" :is-loading="isLoading" />
                        </div>

                        <div v-if="active === 'transactions' && entityType === 'driver'">
                            <EntityDetailsCashJournalTransactions
                                :transactions="cashJournalTransactions"
                                :is-loading="isLoading"
                                :current-month="currentMonth"
                            />
                        </div>
                    </template>
                </Tabs>

                <EntityDetailsQuickActions
                    :show="showQuickActions"
                    :entity-type="entityType"
                    :is-plan-basic="isPlanBasic"
                    @navigate="handleNavigate"
                />
            </template>
        </div>
    </Modal>
</portal>
